import React from 'react'
import {Pressable, Text, View} from 'react-native'

import {CoinAvatar} from './CoinAvatar'
import {Sparkline} from './Sparkline'

type Props = {
  symbol: string
  name: string
  priceUsd?: number
  change24hPct?: number
  sparkline?: number[]
  imageUrl?: string
  watched: boolean
  onToggleWatch: () => void
  onPress: () => void
}

const formatUsd = (value?: number) => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—'
  return `$${value.toLocaleString('en-US', {maximumFractionDigits: 2})}`
}

const formatPct = (value?: number) => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—'
  const pct = value * 100
  return `${pct >= 0 ? '+' : ''}${pct.toFixed(2)}%`
}

export function WatchlistRow({
  symbol,
  name,
  priceUsd,
  change24hPct,
  sparkline,
  imageUrl,
  watched,
  onToggleWatch,
  onPress,
}: Props) {
  const changeColor =
    typeof change24hPct === 'number'
      ? change24hPct >= 0
        ? 'text-emerald-500'
        : 'text-rose-500'
      : 'text-neutral-500 dark:text-neutral-400'
  const sparklineColor =
    typeof change24hPct === 'number' && change24hPct < 0
      ? '#f87171'
      : '#34d399'

  return (
    <View className="w-full flex-row items-center justify-between rounded-2xl border border-black/10 bg-white/80 px-4 py-3 shadow-sm dark:border-white/10 dark:bg-neutral-900/70">
      <Pressable
        accessibilityRole="button"
        onPress={onPress}
        className="flex-1 flex-row items-center justify-between active:opacity-90">
        <View className="min-w-0 flex-row items-center gap-3">
          <CoinAvatar symbol={symbol} imageUrl={imageUrl} size={40} />
          <View className="min-w-0">
            <Text className="text-sm font-semibold text-neutral-900 dark:text-white">
              {symbol}
            </Text>
            <Text className="text-xs text-neutral-500 dark:text-neutral-400" numberOfLines={1}>
              {name}
            </Text>
          </View>
        </View>
        <View className="items-end gap-2">
          <Sparkline points={sparkline} color={sparklineColor} />
          <Text className="text-sm font-semibold text-neutral-900 dark:text-white">
            {formatUsd(priceUsd)}
          </Text>
          <Text className={`text-xs ${changeColor}`}>
            {formatPct(change24hPct)}
          </Text>
        </View>
      </Pressable>
      <Pressable
        accessibilityRole="button"
        onPress={onToggleWatch}
        className="ml-4 rounded-full border border-black/10 px-2.5 py-1 active:opacity-90 dark:border-white/15">
        <Text className="text-xs text-neutral-700 dark:text-neutral-200">
          {watched ? 'Retirer' : 'Suivre'}
        </Text>
      </Pressable>
    </View>
  )
}
